import { app } from '../app.module'
/**
 * LoginService ログイン機能関連のサービス
 * @param  {Function} Restangular Restangular
 * @param  {Function} $q Promise用
 * @return {Object} オブジェクト
 */
function LoginService(Restangular, $q) {
  /**
   * login ログイン処理
   * @param {String} email メールアドレス
   * @param {String} password パスワード
   * @return {Object} ログイン結果
   */
  function login(email: string, password: string): { loginResult: boolean } {
    // Promise用にdeferredオブジェクトを作成
    const deferred = $q.defer()

    // ログイン情報
    const loginInfo = {
      email: email,
      password: password,
    }

    // ログイン情報をチェック
    Restangular.all('/login/login')
      .post(loginInfo)
      .then((loginResult) => {
        // 結果をresolveにセット
        deferred.resolve(loginResult)
      })
    // promiseの結果を返す
    return deferred.promise
  }

  return {
    // ログイン処理
    login: login,
  }
}

// ログイン機能用のサービスを定義
app.factory('LoginService', LoginService)
